import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button } from 'antd';
import logo from '../../img/logo.png'
import callme from '../../img/callme.png'
import {
  Link, useHistory
} from "react-router-dom";
import './layout.scss';
import { getCookie, removeCookie } from '../../utils/session';
import { LogoutOutlined, MenuOutlined, CloseOutlined, CaretRightOutlined, WhatsAppOutlined } from '@ant-design/icons';
const footerStyle = {
  padding: "8px 50px",
  background: "#42423d",
  color: "#fff",
  textAlign: "center"
}
const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;

const GuestLayout = ({ children, profile }) => {
  let history = useHistory();
  const { pathname } = history.location;

  const checkActiveClass = (url) => (pathname === url ? 'ant-menu-item-selected' : '');
  const currentMenu = ['/', "/about-art-camp", "/how-it-works", "/start-learning", "/enquiry"].indexOf(pathname);

  const [state, setState] = useState({
    currentMenu,
    collapsed: true
  })
  const updateMenuItem = ({ key }) => {
    setState(key)
  }

  const userId = getCookie("user_id");

  const { collapsed } = state;
  const toggleMenu = () => {
    setState({ ...state, collapsed: !collapsed })
  }
  const redirectTo = () => {
    removeCookie("user_id");
    history.push("/start-learning/login");
  }
  useEffect(() => {
    setState({ ...state, collapsed: true })
  }, [history.location]);
  return (
    <Layout className="guest-container">
      <Header className="header">
        <div className="logo main-logo">
          <Link to="/"><img src={logo} alt="" /></Link>
        </div>

        {
          collapsed ?
            <MenuOutlined onClick={() => {
              toggleMenu()
            }} className="mobileMenu" />
            : <CloseOutlined className="mobileMenu" onClick={() => {
              toggleMenu()
            }} />
        }
        <Button className="tab-start-learning" danger>
          <Link to={userId ? "/user" : "/start-learning/login"}>Start Learning <CaretRightOutlined /></Link>
        </Button>

        <Menu className={collapsed ? "siteMenu" : "siteMenu expand"} theme="dark" mode="horizontal " defaultSelectedKeys={[state]} style={{ float: 'right' }} onClick={updateMenuItem}>

          <Menu.Item key="1" className={checkActiveClass('/')}>
            <Link to="/">Home</Link>
          </Menu.Item>
          <Menu.Item key="2" className={checkActiveClass('/about-art-camp')}>
            <Link to="/about-art-camp">About Art Camp</Link>
          </Menu.Item>
          <Menu.Item key="3" className={checkActiveClass('/start-learning')}>
            <Link to={userId ? "/user" : "/start-learning/login"}>Start Learning</Link>
          </Menu.Item>
          <Menu.Item key="4" className={checkActiveClass('/enquiry')}>
            <Link to="/enquiry">Enquiry</Link>
          </Menu.Item>
          {
            userId && (
              <div className="profile-title">
                Hello {profile && profile.name}...!
                <Link to="#" onClick={redirectTo}>
                  Logout <LogoutOutlined />
                </Link>
              </div>
            )
          }
        </Menu>

      </Header>
      <Content>
        <Layout className="site-layout-background" style={{ padding: '24px' }}>
          <Content style={{ padding: '0', minHeight: 500 }}>
            {children}
          </Content>
        </Layout>
      </Content>
      <Footer className="guest-layout-footer">
        <div>Virtual Art Camp ©2021, Created by TYCL</div>
      </Footer>
    </Layout>
  )
}

export default GuestLayout;